import { Stack, CardContent, useTheme } from '@mui/material';
import Card from '@mui/material/Card';

export default function FormInsideCard(props: any) {
	const theme = useTheme();
	return (
		<Card
			sx={{
				maxWidth: '90%',
				borderRadius: '8px',
				boxShadow: 'none!important',
				border: '1px solid #cbdcde',
				[theme.breakpoints.down('sm')]: {
					padding: '8px',
				},
			}}
		>
			<CardContent
				sx={{
					padding: '16px!important',
					boxShadow: 'none!important',
					...props.sx,
				}}
			>
				<Stack
					spacing={5}
					sx={{
						[theme.breakpoints.down('sm')]: {
							padding: '12px',
						},
					}}
				>
					{props.children}
				</Stack>
			</CardContent>
		</Card>
	);
}
